import React, { createContext, useRef, useCallback } from 'react';

const DataCacheContext = createContext({
  read: () => [undefined, () => {}],
  save: () => () => {},
});

const getKey = (keyOrParams) =>
  typeof keyOrParams === 'string' ? keyOrParams : JSON.stringify(keyOrParams);

export const DataCacheProvider = ({ children }) => {
  const dataRegistry = useRef({});

  const save = useCallback((keyOrParams, data) => {
    const key = getKey(keyOrParams);

    dataRegistry.current = {
      ...dataRegistry.current,
      [key]: data,
    };

    return () => clean(key);
  }, []);

  const read = useCallback((keyOrParams) => {
    const key = getKey(keyOrParams);
    return [dataRegistry.current[key], () => clean(key)];
  }, []);

  const clean = useCallback((keyOrParams) => {
    const key = getKey(keyOrParams);
    /* eslint-disable-next-line */
    const { [key]: omitted, ...other } = dataRegistry.current;
    dataRegistry.current = other;
  }, []);

  return (
    <DataCacheContext.Provider value={{ read, save }}>
      {children}
    </DataCacheContext.Provider>
  );
};

export default DataCacheContext;
